import React from "react";
import { Container } from "semantic-ui-react";
import { Heading1 } from "../../../components/value-cssmodules/TextComponent";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";
import styles from "./Title.module.scss";

const Title = () => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get("categories");

  const title = selectedCategory
    ? intl.formatMessage(
        {
          id: `categories.categories.${selectedCategory}`,
          defaultMessage: selectedCategory,
        }
      )
    : intl.formatMessage({
        id: "category.page.titleAll",
        defaultMessage: "All categories",
      });

  return (
    <header className={styles.title}>
      <Container>
        <Heading1>{title}</Heading1>
      </Container>
      <div className={styles.titleBorder} />
    </header>
  );
};

export default Title;
